var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RevampedLoginChevron(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25623 16C1.00816 16.0013 0.765271 15.935 0.558542 15.8096C0.351813 15.6841 0.190607 15.5052 0.0954772 15.2956C0.000347357 15.086 -0.0243966 14.8553 0.0244002 14.6327C0.073197 14.4102 0.193324 14.2061 0.369464 14.0463L6.989 8.00233L0.369464 1.95839C0.134279 1.74325 0.00215325 1.45145 0.00215326 1.1472C0.00215326 0.842941 0.134279 0.551147 0.369464 0.336006C0.60465 0.120865 0.92363 2.26688e-09 1.25623 0C1.58883 -2.26688e-09 1.90781 0.120865 2.143 0.336006L9.63681 7.19114C9.86943 7.4052 10 7.69478 10 7.99662C10 8.29845 9.86943 8.58803 9.63681 8.80209L2.143 15.6572C2.02733 15.7652 1.88939 15.8511 1.73717 15.9099C1.58495 15.9687 1.42148 15.9994 1.25623 16Z",
    fill: "url(#paint0_linear_0_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 5,
    y1: 16,
    x2: 5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RevampedLoginChevron);
export default __webpack_public_path__ + "static/media/v2_revamped_login_chevron.97a9a09c91ae9e2e4dc359c3abf50fec.svg";
export { ForwardRef as ReactComponent };